import React from 'react';
import { CardComponent, Body, Image, Footer, Header } from './styles.js';

const Card = (props) => {
    return React.createElement(CardComponent, Object.assign({ as: props.href ? 'a' : 'div' }, props));
};
Card.Body = Body;
Card.Image = Image;
Card.Footer = Footer;
Card.Header = Header;

export { Card as default };
